import React, { useEffect, useState } from "react";
import Card from "react-credit-cards";
import NumberFormat from "react-number-format";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";

import { Button, Input, Label } from "..";
import { notification } from "../../../services/helpers";
import { addCardRequest } from "../../requests";
import { validateCard } from "../../utils";
import * as Styles from "./styles";

const inputs = [
  {
    name: "number",
    label: "Número do cartão",
    placeholder: "5555 **** **** 7181",
    mask: "####.####.####.####",
  },
  {
    name: "name",
    label: "Nome titular",
    placeholder: "José da Silva",
    pattern: /[^A-zÀ-ú ]/g,
    maxLength: 40,
    minLength: 4,
  },
  {
    name: "expiry",
    label: "Data de vencimento",
    placeholder: "04/23",
    mask: "##/##",
  },
  {
    name: "cvc",
    label: "CVV",
    placeholder: "***",
    mask: "###",
  },
  {
    name: "cpf",
    label: "CPF",
    placeholder: "123.456.789-10",
    mask: "###.###.###-##",
  },
];

export function AddCardForm({ onCancel, onAddCard, msisdn, setIsLoading }) {
  const {
    register,
    setValue,
    watch,
    handleSubmit,
    formState: { errors },
    setFocus,
  } = useForm({
    defaultValues: {
      number: "",
      name: "",
      expiry: "",
      cvc: "",
      cpf: "",
    },
    resolver: (data) => {
      let errorMessages = validateCard(data);

      return {
        values: data,
        errors: errorMessages,
      };
    },
  });
  const [focusedInput, setFocusedInput] = useState();

  const { number, name, expiry, cvc } = watch();

  function handleInputFocus({ target }) {
    setFocusedInput(target.name);
  }

  const onSubmit = async (data) => {
    try {
      setIsLoading(true);
      const response = await addCardRequest({
        ...data,
        msisdn,
      });

      if (response.data.code !== "P00")
        return notification("error", response.data.msg);

      onAddCard();
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!!errors && Object.keys(errors).length > 0) {
      const errorField = Object.keys(errors)[0];
      Swal.fire({
        title: "Erro!",
        type: "error",
        text: errors[errorField],
      });

      setFocus(errorField);
    }
  }, [errors]);

  return (
    <Styles.AddCardContainer onSubmit={handleSubmit(onSubmit)}>
      <Styles.FormContainer>
        <div id="form-inputs">
          {inputs.map(({ name, label, mask, pattern, ...props }) => (
            <Styles.FormField key={name}>
              <Label htmlFor={name}>{label}</Label>
              {!mask ? (
                <Input
                  id={name}
                  variant="underline"
                  required
                  {...props}
                  {...register(name, {
                    onChange: (e) => {
                      if (pattern)
                        setValue(name, e.target.value.replace(pattern, ""));
                    },
                  })}
                />
              ) : (
                <NumberFormat
                  id={name}
                  {...register(name)}
                  variant="underline"
                  customInput={Input}
                  format={mask}
                  required
                  {...props}
                  onValueChange={({ value }) => setValue(name, value)}
                  onFocus={handleInputFocus}
                />
              )}
            </Styles.FormField>
          ))}
        </div>
        <Card
          cvc={cvc}
          expiry={expiry}
          name={name}
          number={number}
          focused={focusedInput}
        />
      </Styles.FormContainer>
      <Styles.FormFooter>
        <Button
          type="button"
          rounded
          color="#22397b99"
          variant="secondary"
          onClick={onCancel}
        >
          Cancelar
        </Button>
        <Button rounded color="#1dbf00">
          Salvar
        </Button>
      </Styles.FormFooter>
    </Styles.AddCardContainer>
  );
}
